<template>
  <div class="col">
    <label for="exampleDataList" class="form-label">
      <span v-if="cie10_id">Editar Código</span>
      <span v-else>Buscar Código</span>
    </label>
    <Field
      class="form-control"
      list="datalistOptions"
      id="exampleDataList"
      name="cie10_id"
      autocomplete="off"
      placeholder="Buscar código..."
      v-model="selectedOption"
      @change="handleInput"
    />
    <datalist id="datalistOptions">
      <option
        v-for="option in options"
        :value="option.codeDescription"
        :key="option.id"
      ></option>
    </datalist>
    <ErrorMessage name="cie10_id" />
  </div>
</template>

<script>
import { ref, watch, onMounted } from 'vue';
import DataService from "../../services/data.service";
import { Field, ErrorMessage } from "vee-validate";


export default {
  components: {
    Field, 
    ErrorMessage,
  },
  props: ['cie10_id'],
  emits: ['codigoSelected'],
  setup(props, { emit }) {
    const options = ref([]);
    const selectedOption = ref('');
    let timeoutId = null;

    const fetchOptions = async () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
      timeoutId = setTimeout(async () => {
        if (selectedOption.value.length >= 3) {
          try { 
            const response = await DataService.getCieCode(selectedOption.value);

            if (!Array.isArray(response.data)) {
              console.error('La respuesta no es un array');
              return;
            }

            options.value = response.data.map((item) => ({
              id: item.id,
              codeDescription: `${item.codigo} - ${item.descripcion}`,
            }));
          } catch (error) {
            console.error('Error fetching options:', error);
          }
        }
      }, 1000);
    };

    const handleInput = () => {
      const selectedCodeDescription = selectedOption.value;
      const selectedOptionData = options.value.find(
        (option) => option.codeDescription === selectedCodeDescription
      );
      if (selectedOptionData) {
        const codigoId = selectedOptionData.id;
        emit('codigoSelected', codigoId);
      }
    };

    onMounted(() => {
      const modalElement = document.getElementById('fichaModal');
      modalElement.addEventListener('hidden.bs.modal', () => {
        selectedOption.value = '';
      });
    });

    watch(selectedOption, fetchOptions);

    return {
      options,
      selectedOption,
      handleInput,
    };
  },
};
</script>
